export default {
    viewBox: "0 0 25 24",
    paths: [
        "M22.3116 1.5L23.457 2.64545L14.102 12L23.457 21.3545L22.3116 22.5L12.957 13.145L3.60248 22.5L2.45703 21.3545L11.811 12L2.45703 2.64546L3.60248 1.5L12.957 10.854L22.3116 1.5Z"
    ]
};